import React from "react";

export default function IconCheckmark(props) {
  return (
    <svg viewBox="0 0 14 11" {...props}>
      <path
        fill="none"
        stroke="#A82D9C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 6.559L4.25 10 13 1"
      />
    </svg>
  );
}
